import { render, staticRenderFns } from "./ScreenControls.vue?vue&type=template&id=6d206aa6&scoped=true&"
import script from "./ScreenControls.vue?vue&type=script&lang=ts&"
export * from "./ScreenControls.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenControls.vue?vue&type=style&index=0&id=6d206aa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d206aa6",
  null
  
)

export default component.exports